import React, { useState, useEffect } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';

import db from '../../firebase';

import './index.scss';
import Card from '../../components/Card/Card';
import Skeleton from '../../components/Skeleton/Skeleton';


const PortfolioPage = () => {
    const [projects, setProjects] = useState([]);

    useEffect(() => {
      return onSnapshot(collection(db, "projects"), (snapshot) =>
        setProjects(snapshot.docs.map((doc) => (
          {
            id: doc.id,
            ...doc.data()
          }
        )))
      );
    }, []);

    return (
        <div className="portfolio__page page">
            <div className="page__title"><h1>Portfolio</h1></div>
            <div className="portfolio__content">
            
            { projects.length ? projects.map(project => (
                <Card
                    key={project.id}
                    title={project.title}
                    description={project.description}
                    photo={project.photo} 
                    demo={project.demo}
                    github={project.github}
                    tags={project.tags}
                 />
             
            )) : <div className="skeleton__wrapper">
                   { Array(9)
                        .fill(0)
                        .map((_, index) => <Skeleton key={index} />)}
                </div> 
            }
            

            {/* <Card
                title={'Twitter Clone'}
                photo={'data:image/png;base64,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'}
                demo={'https://discord-clone-925c1.web.app/'}
            />
            <Card
                title={'Netflix'}
                photo={'https://www.simula.no/sites/default/files/articles/images/netflix-new-icon.png'}
                demo={'https://discord-clone-925c1.web.app/'}
            /> */}
            
            </div>
           
        </div>
    );
}

export default PortfolioPage;
